import React, { FC } from 'react';
import * as StyledWizardSteps from './wizardSteps.styles';

export interface IWizardStep {
	name: string;
}

interface Props {
	steps: IWizardStep[];
	onStepClick: any;
	page: number;
	markLastStepAsCompleted?: boolean;
	onLastStep?: boolean;
}

const WizardSteps: FC<Props> = ({ steps, onStepClick, page, markLastStepAsCompleted, onLastStep }) => {
	return (
		<StyledWizardSteps.Wrapper>
			{steps.map((step, index) => {
				const isLast = index >= steps.length - 1;
				const isNotLast = !isLast;
				const isLastAndFulfilled = markLastStepAsCompleted && isLast && page >= steps.length - 1;
				const fulfilled = page > index || isLastAndFulfilled;
				const active = page === index && !isLastAndFulfilled;
				return (
					<StyledWizardSteps.StepWrapper key={index}>
						<StyledWizardSteps.StepInner>
							<StyledWizardSteps.StepBubbleOuter
								fulfilled={fulfilled}
								disabled={!fulfilled}
								onClick={onLastStep ? null : onStepClick.bind(null, index)}
								last={onLastStep}
								active={active}>
								<StyledWizardSteps.StepBubble active={active} fulfilled={fulfilled}>
									{fulfilled ? '✓' : (index + 1).toString()}
								</StyledWizardSteps.StepBubble>
							</StyledWizardSteps.StepBubbleOuter>
							<StyledWizardSteps.StepName>{step.name}</StyledWizardSteps.StepName>
						</StyledWizardSteps.StepInner>
						{isNotLast && (
							<StyledWizardSteps.StepConnector
								fulfilled={page === index + 1}
								fulfilledTotal={page >= index + 2}
								active={active}
							/>
						)}
					</StyledWizardSteps.StepWrapper>
				);
			})}
		</StyledWizardSteps.Wrapper>
	);
};

export default WizardSteps;
